import React, {Component} from "react";
import FlexView from "react-flexview";
import M from "moment";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";

class OnSubmissionFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: {},
            dataVariant: [],
            dataWarna: [],
        };
    }

    render() {
        return (
            <SimpleModal
                title="Filter Search"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <FlexView column>
                            <SimpleInput
                                id="input_text_sales_invoice_number"
                                name="noFakturJual"
                                label="No. Faktur Jual"
                                value={this.props.filterData.noFakturJual}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <FlexView column vAlignContent="center">
                                <p>Tanggal Pengajuan:</p>
                                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                    <SimpleDate
                                        date={this.props.filterData.startDateSubmission}
                                        onChange={(value) =>
                                            this.props.onValueChange("startDateSubmission", M(value).format("DD-MM-YYYY"))
                                        }
                                    />
                                    <span className="margin-bottom-20px">To</span>
                                    <SimpleDate
                                        date={this.props.filterData.endDateSubmission}
                                        onChange={(value) =>
                                            this.props.onValueChange("endDateSubmission", M(value).format("DD-MM-YYYY"))
                                        }
                                    />
                                </FlexView>
                            </FlexView>
                            <SimpleInput
                                id="input_text_leasing_name"
                                name="namaSamsat"
                                label="Nama SAMSAT"
                                value={this.props.filterData.namaSamsat}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_recipient_name"
                                name="namaBirojasa"
                                label="Nama Birojasa"
                                value={this.props.filterData.namaBirojasa}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_stnk_name"
                                name="stnkName"
                                label="Nama STNK"
                                value={this.props.filterData.stnkName}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_buyer_name"
                                name="customerName"
                                label="Nama Pembeli"
                                value={this.props.filterData.customerName}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_frame_number"
                                name="frameNumber"
                                label="Nomor Rangka"
                                value={this.props.filterData.frameNumber}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_engine_number"
                                name="engineNumber"
                                label="Nomor Mesin"
                                value={this.props.filterData.engineNumber}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                        </FlexView>
                        <FlexView hAlignContent="right" style={{gap: "10px"}}>
                            <SimpleButton
                                type="button"
                                text={"Hapus"}
                                onClick={this.props.onClearForm}
                            />
                            <SimpleButton
                                type="submit"
                                text={"Terapkan"}
                                onClick={this.props.onSubmit}
                            />
                        </FlexView>
                        <SimpleLoadingOverlay active={this.state.loading}/>
                    </ModalContainer>
                }
            />
        );
    }
}

export default OnSubmissionFilter;
